// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorIcon_root__38dap"};